import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {LibraryDialogController} from '../LibraryDialog.controller';
import {LibraryDialogCarousel} from '../LibraryDialogCarousel';
import classNames from 'classnames';

@observer
export class LibraryDialogToolbar extends TechseeBaseComponent<{ctrl: LibraryDialogController}> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        // Access observables to create MobX dependencies
        const showFooter = ctrl.showFooter;

        if (!showFooter) {
            return <div />;
        }

        return (
            <div className='modal-footer-content'>
                <div className='carousel-container'>
                    <LibraryDialogCarousel ctrl={ctrl} />
                </div>
                <div className='footer-buttons'>
                    <a
                        href='#'
                        className={classNames({'btn-disabled': !ctrl.canAnnotate})}
                        onClick={(e) => {
                            e.preventDefault();
                            if (ctrl.canAnnotate) {
                                ctrl.annotateItem();
                            }
                        }}>
                        <img src={ctrl.requireImage('icon-annotate.png')} alt='Annotate' />
                        <div>{ctrl.translate('LIBRARY.VIEW.ANNOTATE')}</div>
                    </a>
                    {!ctrl.offlineMode && (
                        <a
                            href='#'
                            className={classNames({inactive: !ctrl.canSend})}
                            onClick={(e) => {
                                e.preventDefault();
                                if (ctrl.canSend) {
                                    ctrl.sendItem();
                                }
                            }}>
                            <img src={ctrl.requireImage('send-gallery.png')} alt='Send' />
                            <div>{ctrl.translate('LIBRARY.VIEW.SEND')}</div>
                        </a>
                    )}
                </div>
            </div>
        );
    }
}
